
import { getStandardMetadataDisplayName, RecordMetadataKey } from "@/shogi";
import { Mutation, useStore } from "@/store";
import { computed, defineComponent } from "vue";
import { RectSize } from "../primitive/Types";

export default defineComponent({
  name: "RecordComment",
  props: {
    size: {
      type: RectSize,
      required: true,
    },
  },
  setup() {
    const store = useStore();
    const list = computed(() => {
      return Object.values(RecordMetadataKey).map((key) => {
        const metadata = store.state.record.metadata;
        return {
          key: key,
          displayName: getStandardMetadataDisplayName(key),
          value: metadata.getStandardMetadata(key) || "",
        };
      });
    });

    const change = (event: Event, key: string) => {
      const input = event.target as HTMLInputElement;
      store.commit(Mutation.UPDATE_STANDARD_RECORD_METADATA, {
        key,
        value: input.value,
      });
    };

    return {
      list,
      change,
    };
  },
});
